import { auth } from './chunk-GAKGNVWY.js';
import { config } from './chunk-WHCMK6SD.js';

// src/util/permissions/index.ts
var entitlementOverrides = /* @__PURE__ */ new Map();
function accountHas(entitlement) {
  const session = auth.getCache();
  if (!session) {
    return false;
  }
  const override = entitlementOverrides.get(entitlement);
  if (typeof override === "boolean") {
    return override;
  }
  return session.features.includes(entitlement);
}
accountHas.setOverride = (entitlement, state) => {
  if (config.select((c) => c.env)() === "prd" && !import.meta.env.TEST) {
    return;
  }
  if (state === null) {
    entitlementOverrides.delete(entitlement);
  } else {
    entitlementOverrides.set(entitlement, state);
  }
};
var readonlyFactors = {
  debug: false,
  impersonatingUser: false,
  botrApiMaintenance: false
};
function userCan(...[action, level, permission, siteId]) {
  const session = auth.getCache();
  if (!session) {
    return false;
  }
  if (
    // If some external factor is setting read-only state
    Object.values(readonlyFactors).some((state) => state === true) && // Only 'view' actions are allowed
    action !== "view"
  ) {
    return false;
  }
  let allowedActions = [];
  if (level === "account") {
    allowedActions = session.permissions.actions[permission] ?? [];
  }
  if (level === "site") {
    if (siteId === void 0) {
      return false;
    }
    const site = session.sites.find(({ site_id }) => site_id === siteId);
    if (!site) {
      return false;
    }
    allowedActions = site.permissions.actions[permission] ?? [];
  }
  return allowedActions.includes(action);
}
userCan.setReadonlyFactor = (factor, state) => {
  readonlyFactors[factor] = state;
};
var permissions = {
  userCan,
  accountHas
};

export { accountHas, permissions, userCan };
